import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { AuthService } from './services/auth-service';
import { AuthGuard } from './guards/auth.guard';
import { RouterModule, Routes } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignInSilentComponent } from './sign-in-silent/sign-in-silent.component';

export const authRoutes: Routes = [
    { path: 'sign-in', component: SignInComponent },
    { path: 'sign-in-silent', component: SignInSilentComponent }
];

@NgModule({
    imports: [CommonModule, HttpClientModule, RouterModule],
    declarations: [SignInComponent, SignInSilentComponent]
})
export class AuthModule {
    static forRoot(): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                AuthGuard,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: TokenInterceptor,
                    multi: true
                }
            ]
        };
    }
}
